import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Home from '../../pages/dashboard/Home';
import MyResearch from '../../pages/dashboard/MyResearch';
import Sienaguard from '../../pages/dashboard/Sienaguard';
import Payments from '../../pages/dashboard/Payments';
import Settings from '../../pages/dashboard/Settings';
import Loader from '../../components/Loader';
import ParticlesDashboardComponent from '../../components/particles/Particles_dashboard';
import useAuth from '../../hooks/useAuth';
import Dema from '../../pages/dashboard/Dema';
import Admin from './admin/Admin';
import Tools from './Tools/Tools';
import Premium from './Premium/Premium';

const Dashboard: React.FC = () => {
  const { isLoggedIn, user, loading, error } = useAuth();
  const navigate = useNavigate();
  const [activePage, setActivePage] = React.useState('home');

  const isPremium = user?.user_type === 'premium';

  // Redirigir al login si la sesión expiró
  React.useEffect(() => {
    if (!isLoggedIn && !loading) {
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }
  }, [isLoggedIn, loading, navigate]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <p className="text-red-500 text-xl font-semibold">{error}</p>
        </div>
      </div>
    );
  }

  const renderPage = () => {
    switch (activePage) {
      case 'home':
        return <Home />;
      case 'myResearch':
        return <MyResearch />;
      case 'sienaguard':
        return <Sienaguard />;
      case 'payments':
        return <Payments />;
      case 'settings':
        return <Settings />;
      case 'myCompetitors':
        return <Dema />;
      case 'admin':
        return <Admin />;
      case 'tools':
        return (
          <Tools
            isPremium={isPremium}
            goToPremium={() => setActivePage('premium')}
          />
        );
      case 'premium':
        return (
          <Premium
            isPremium={isPremium}
            goToMyResearch={() => setActivePage('myResearch')}
          />
        );
      default:
        return <Home />;
    }
  };

  return (
    <div className="relative h-screen flex">
      <ParticlesDashboardComponent />
      <Sidebar
        setActivePage={setActivePage}
        isAdmin={user?.is_admin}
        activePage={activePage}
      />
      <main className="flex-1 p-8 overflow-y-auto relative z-10">
        {renderPage()}
      </main>
    </div>
  );
};

export default Dashboard;
